import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import BaseModal from '../../../../components/BaseModal/BaseModal'
import Modal from '../../../../components/Modal'
import Style from './InviteUserModal.module.css'
import ModalHeading from '../../../../components/Modal/ModalHeading'
import InviteUserInput from './InviteUserInput/InviteUserInput'
import Button from '../../../../components/Button'
import ModalButtons from './ModalButtons/ModalButtons'

const InviteUserModal = ({ showModal, setShowModal }) => {
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState('email');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    return (
        <BaseModal showModal={showModal} className={Style.inviteModal} overlayStyle={Style.overlayStyle}>
            <div className={Style.modalHeading}>
                <span className={Style.heading}>{t('screens.chat.groupInviteFor')}<span style={{ fontWeight: '800' }}>”Regure”</span></span>
                <svg className={Style.closeIcon} onClick={() => setShowModal(false)}>
                    <use xlinkHref={`/assets/sprite.svg#${'icon-invite-user-close'}`} />
                </svg>
            </div>
            <div className={Style.modalContainer}>
                <div className={Style.optionContainer}>
                    <label className={Style.radio_label}>
                        <input
                            type="radio"
                            value="email"
                            checked={selectedOption === 'email'}
                            onChange={handleOptionChange}
                        />
                        <span className={Style.radio_custom}></span>
                        {t('screens.chat.email')}
                    </label>

                    <label className={Style.radio_label}>
                        <input
                            type="radio"
                            value="textMessage"
                            checked={selectedOption === 'textMessage'}
                            onChange={handleOptionChange}
                        />
                        <span className={Style.radio_custom}></span>
                        {t('screens.chat.textMessage')}
                    </label>

                </div>
                <div>
                    <InviteUserInput email={selectedOption === 'email' ? true : false} />
                </div>
                <div>
                <ModalButtons
							submitButtonLabel={t('screens.chat.sendInvite')}
							// onSubmit={handleRemoveUser}
							cancelButtonLabel={t('screens.chat.cancel')}
							onCancel={() => setShowModal(false)}
						/>
                </div>
            </div>
        </BaseModal >
    )
}

export default InviteUserModal
